{
  "about": {
    "title": "About Spring Boot Admin",
    "label": "About"
  }
}
